import { isEqual } from "~/shared/utils";

import { BaseInputDependencies } from "../Input.d";

import { getErrorIdFromDataId } from "./getErrorIdFromDataId";

export const makeInputError = <T>({
	validate,
	serverError,
	value,
	"data-testid": dataId,
}: BaseInputDependencies<T>): string | null => {
	const serverResult = (() => {
		if (!serverError) return null;

		const { id, message } = serverError;

		if (isEqual(getErrorIdFromDataId(dataId), id)) return message;

		return null;
	})();
	const clientResult = validate?.(value);

	return clientResult ?? serverResult;
};
